import { createApi } from '@reduxjs/toolkit/query/react'
import { HYDRATE } from 'next-redux-wrapper'

import { BusinessSectorListRequest, BusinessSectorListResponse } from '@/types/business-sector'
import { apiBaseQuery } from '@/utils/api'

const api = createApi({
  reducerPath: 'businesses-sector',
  baseQuery: apiBaseQuery,
  tagTypes: ['Businesses Sector'],
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 259200, // 3 days
  endpoints: (builder) => ({
    getListBusinessSector: builder.query<BusinessSectorListResponse, BusinessSectorListRequest>({
      query: (sezRegionListRequest) => ({
        ...sezRegionListRequest,
        url: '/v1/sez-regions/businesses-sector',
        providesTags: ['Businesses Sector'],
      }),
    }),
  }),
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath]
    }
  },
})

// Export hooks for usage in functional components
export const { useLazyGetListBusinessSectorQuery, util: businessSectorUtil } = api

export default api
